import { useState } from 'react';
import { Phone, Mail, MapPin, Send } from 'lucide-react';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real implementation, you would handle form submission here
    console.log('Form submitted:', formData);
    alert('Pesan Anda telah dikirim. Kami akan segera menghubungi Anda.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: '',
    });
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="section-title mx-auto inline-block after:left-1/2 after:-translate-x-1/2">
            Hubungi Kami
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto mt-6">
            Punya pertanyaan atau ingin bekerja sama? Hubungi kami dan kami akan segera menghubungi Anda kembali.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Information */}
          <div>
            <h3 className="text-2xl font-bold mb-6 text-navy-900">Informasi Kontak</h3>
            
            <div className="space-y-6 mb-8">
              <div className="flex items-start">
                <div className="bg-primary-600 p-3 rounded-full text-white mr-4">
                  <MapPin size={24} />
                </div>
                <div>
                  <h4 className="font-semibold text-navy-900 mb-1">Alamat Kantor</h4>
                  <p className="text-gray-600">
                    Jl. Juwingan No 94, Gubeng Kertajaya, <br />
                    Surabaya, Jawa Timur, Indonesia
                  </p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="bg-primary-600 p-3 rounded-full text-white mr-4">
                  <Phone size={24} />
                </div>
                <div>
                  <h4 className="font-semibold text-navy-900 mb-1">Telepon</h4>
                  <p className="text-gray-600">+62 877-1208-1994</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="bg-primary-600 p-3 rounded-full text-white mr-4">
                  <Mail size={24} />
                </div>
                <div>
                  <h4 className="font-semibold text-navy-900 mb-1">Email</h4>
                  <p className="text-gray-600">info@samuderaalam.com</p>
                </div>
              </div>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h4 className="font-semibold text-navy-900 mb-4">Jam Operasional</h4>
              <div className="space-y-2">
                <div className="flex justify-between">
                  <span className="text-gray-600">Senin - Jumat</span>
                  <span className="font-medium">08:00 - 17:00</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Sabtu</span>
                  <span className="font-medium">09:00 - 14:00</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Minggu & Libur</span>
                  <span className="font-medium">Tutup</span>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-white rounded-lg shadow-md p-8">
            <h3 className="text-2xl font-bold mb-6 text-navy-900">Kirim Pesan</h3>
            
            <form onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                    Nama Lengkap <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary-600 focus:border-primary-600"
                    required
                  />
                </div>
                
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                    Email <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary-600 focus:border-primary-600"
                    required
                  />
                </div>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
                    Nomor Telepon
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary-600 focus:border-primary-600"
                  />
                </div>
                
                <div>
                  <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1">
                    Subjek <span className="text-red-500">*</span>
                  </label>
                  <select
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary-600 focus:border-primary-600"
                    required
                  >
                    <option value="" disabled>Pilih Subjek</option>
                    <option value="Informasi Layanan">Informasi Layanan</option>
                    <option value="Kerjasama Bisnis">Kerjasama Bisnis</option>
                    <option value="Rekrutmen">Rekrutmen</option>
                    <option value="Lainnya">Lainnya</option>
                  </select>
                </div>
              </div>
              
              <div className="mb-6">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                  Pesan <span className="text-red-500">*</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows={5}
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary-600 focus:border-primary-600"
                  required
                ></textarea>
              </div>
              
              <button
                type="submit"
                className="btn btn-primary w-full flex items-center justify-center"
              >
                <Send size={18} className="mr-2" />
                Kirim Pesan
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;